<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process-custom"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

const reportTypes = Object.freeze({
  EDUCATIVE: 'educative',
  THERAPY: 'therapy'
});

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({   
    model: {
      search: {
        collections: {
          ores: [],
          academicYears: [],
          centers: [],
          serviceCenters: [],
          municipalities: [],
          schools: [],
        },
        filters: {
          academicYear: null,
          ore: null,
          center: null,
          centerDisabled: true,          
          municipality: null,
          municipalityDisabled: true,
          school: null,
          schoolDisabled: true,
          serviceCenter: null,
        },
        transportationOptions: [
          { id: 1, displayName: 'Si', value: true },
          { id: 2, displayName: 'No', value: false}
        ]
      },
    },
  }),
  computed: {
    reportType(){
      return this.$route.params.type;
    },
    page() {
      return {
        icon: 'fas fa-clipboard-list-check',
        title: `Estudiantes Elegibles AEE ${this.reportType == reportTypes.THERAPY ? "- (Terapias)" : ""}`,
        routes: ["Informes", `Estudiantes Elegibles AEE ${this.reportType == reportTypes.THERAPY ? "- (Terapias)" : ""}`]
      };
    },    
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        clearable: false,
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: "col-md-3",
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangedAcademicYears,
      },
      {
        name: 'ore',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'ORE',
        placeholder: 'Seleccionar',               
        class: "col-md-3",
        options: this.model.search.collections.ores,
        value: this.model.search.filters.ore,
        onChanged: this.onChangedOre
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Centro',
        placeholder: 'Seleccionar',               
        class: "col-md-3",
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        onChanged: this.onChangedCenter,
        disabled: this.model.search.filters.centerDisabled,
      },
      {
        name: 'municipality',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Municipio',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.municipalities,
        value: this.model.search.filters.municipality,
        onChanged: this.onChangedMunicipality,
        disabled: this.model.search.filters.municipalityDisabled,
      },
      {
        name: 'school',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Escuela',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.schools,
        value: this.model.search.filters.school,
        onChanged: this.onChangedSchool,
        disabled: this.model.search.filters.schoolDisabled,
      },   
      {
        name: 'transportation',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'displayName',
        label: 'Transportación',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.transportationOptions,
        value: this.model.search.filters.transportation,
        onChanged: this.onChangedTransportation,
      },
      {
        name: 'serviceCenter',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Centro de Servicio',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.serviceCenters,
        value: this.model.search.filters.serviceCenter,
        visible:
          this.reportType === reportTypes.EDUCATIVE &&
          this.model.search.filters.transportation?.value === true,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {       
      const { data } = await AcademicYearServices.getAcademicYearsFromMinType(2026, 'CURRENT');
      this.model.search.collections.academicYears = data;
      this.model.search.filters.academicYear = data.find(c=> c.selected);
      if (this.model.search.filters.academicYear) {              
        await this.onChangedAcademicYears();
      }        
    },
    async onChangedAcademicYears() {
      this.clearOres();
      this.clearCenters();
      this.model.search.filters.serviceCenter = null;
      this.model.search.collections.serviceCenters = [];
      this.clearMunicipalities();
      this.clearSchools();

      if (!this.model.search.filters.academicYear) {
        this.disabledCenter(true);
        this.disabledMunicipality(true);
        this.disabledSchool(true);
        return false;
      }

      await this.loadServiceCenters();
      await this.getOres();
      if (this.model.search.collections.ores.length === 1) {
        this.model.search.filters.ore = this.model.search.collections.ores[0];
      }
      await this.getCenters();
      this.disabledCenter(false);
    },
    async onChangedOre(){
      this.clearCenters();
      this.clearMunicipalities();
      this.clearSchools();

      if (!this.model.search.filters.academicYear) {
        this.disabledCenter(true);
        this.disabledMunicipality(true);
        this.disabledSchool(true);
        return false;
      }

      await this.getCenters();
      this.disabledCenter(false);
    },
    async onChangedCenter() {
      this.clearMunicipalities();
      this.clearSchools();

      if (!this.model.search.filters.center) {
        this.disabledMunicipality(true);
        this.disabledSchool(true);
        return false;
      }

      await this.getMunicipalities();
      this.disabledMunicipality(false);      
    },
    async onChangedMunicipality() {
      this.clearSchools();
       if (!this.model.search.filters.municipality) {        
        this.disabledSchool(true);
        return false;
      }

      await this.getSchools();      
      this.disabledSchool(false);     
    },  
    async getOres() {
       await LocationServices
        .getOres()
        .then((res) => {
          this.model.search.collections.ores = res.data
        })
    },
    async loadServiceCenters() {
      const { data } = await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      });
      this.model.search.collections.serviceCenters = data;
    },
    async getCenters() {
      const params = {
        academicYearId: this.model.search.filters.academicYear.id,
      };
      if (this.model.search.filters.ore?.id != null) {
        params.regionId = this.model.search.filters.ore.id;
      }
      await LocationServices.getCenters(params)
      .then((res) => {
        this.model.search.collections.centers = res.data
        if (this.model.search.collections.centers.length == 1) {
          this.model.search.filters.center = this.model.search.collections.centers[0]
          this.getMunicipalities()            
          this.disabledMunicipality(false);
        }
      });
        
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      })
      .then((res) => {
        this.model.search.collections.municipalities = res.data
        if (this.model.search.collections.municipalities.length == 1) {
          this.model.search.filters.municipality = this.model.search.collections.municipalities[0]
          this.getSchools()            
          this.disabledSchool(false);
        }
      });
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
      })
      .then((res) => {
        this.model.search.collections.schools = res.data
         if (this.model.search.collections.schools.length == 1) {
          this.model.search.filters.school = this.model.search.collections.schools[0]          
        }
      });
    },   
    disabledCenter(disabled) {
      this.model.search.filters.centerDisabled = disabled;
    },
    disabledMunicipality(disabled) {
      this.model.search.filters.municipalityDisabled = disabled;
    },
    disabledSchool(disabled) {
      this.model.search.filters.schoolDisabled = disabled;
    },  
    clearCenters() {
      this.model.search.filters.center = null;
    },
    onChangedTransportation() {
      if (this.model.search.filters.transportation?.value !== true) {
        this.model.search.filters.serviceCenter = null;
      }
    },
    clearMunicipalities() {
      this.model.search.filters.municipality = null;
    },
    clearSchools() {
      this.model.search.filters.school = null;
    },   
    clearOres() {
      this.model.search.filters.ore = null;
    },   
    async onHandlerSearch() {
     const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {

      let reportName = 'studentaee'
      switch (this.reportType)
      {
        case reportTypes.THERAPY: {
          reportName = 'studentaeetherapy'
          break;
        }
      }
       await ReportServices.getReport(reportName, {        
        academicYearId: this.model.search.filters.academicYear.id,        
        oreId: this.model.search.filters.ore?.id,
        centerId: this.model.search.filters.center?.id,          
        municipalityId: this.model.search.filters.municipality?.id,          
        schoolId: this.model.search.filters.school?.id,      
        showOnlyWithTransportation: this.model.search.filters.transportation?.value,        
        cseeId:
          this.reportType === reportTypes.EDUCATIVE &&
          this.model.search.filters.transportation?.value === true
            ? this.model.search.filters.serviceCenter?.id
            : undefined,
      }).then((res) => DocumentServices.Download(res.data)); 
    },
  },
}
</script>

<style scope>
.btn-process-custom {
	position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>

